import React, {FC} from 'react';
import {Select} from './Select';
import {Checkbox} from "./Checkbox";
import {sortedSizeFilter, sortedSizeObjects, sortedSizes} from '../utils/sortedSizes';
import {ProductSizeCode} from "../types/types";
import {TSortType} from "../pages/ProductListPage";

interface FilterBarProps {
    sortValue: TSortType | undefined;
    onSort: (sortType: string) => void
    sizeFilters: ProductSizeCode[]
    sizeValue: string | undefined
    onSelectSize: (sizeName: string | undefined) => void
    checked: boolean
    onChecked: () => void
}

export const FilterBar: FC<FilterBarProps> = ({sortValue, onSort, sizeFilters, sizeValue, onSelectSize, checked, onChecked}) => {
    return (
        <>
            <div className="flex justify-between">
                <div className={'flex items-center w-full'}>
                    <Select value={sizeValue} defaultValue={undefined} onChange={(e) => onSelectSize(e.target.value || undefined)} className={'w-24'}>
                        {/*<option value={undefined} disabled={true}>사이즈</option>*/}
                        <option value="">전체 사이즈</option>
                        {sortedSizeFilter(sizeFilters).map((item, index) => (
                            <option key={index} value={item.sizeName}>{item.sizeName}</option>
                        ))}
                    </Select>
                    <div className="m-auto md:ml-5 md:w-26">
                        <Checkbox label={'세일상품 보기'}
                                  checked={checked}
                                  onChange={onChecked}
                                  className={''}
                        />
                    </div>
                </div>

                <Select value={sortValue} onChange={(e) => onSort(e.target.value)} className={'w-24 -mr-2'}>
                    <option value={""}>최신순</option>
                    <option value="popularity">인기순</option>
                    <option value="currentPriceAsc">가격 낮은 순</option>
                    <option value="currentPriceDesc">가격 높은 순</option>
                </Select>
            </div>
        </>
    );
};
